// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"91ddcb92","115":"f3dc0a9b","363":"dd1a6619","453":"93959fc3","605":"cf9c59ae","634":"61461f3b","990":"ef72fd18"}[chunkId] + ".chunk.js";
};